import type { SaveFormQrCodeOptions, SaveFormQrCodeResult } from './saveFormQrCode'

export default async function saveFormQrCode(options: SaveFormQrCodeOptions): Promise<SaveFormQrCodeResult> {
  const blob = new Blob([Uint8Array.from(atob(options.dataURI), c => c.charCodeAt(0))], { type: 'image/png' })

  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.download = options.filename
  a.click()

  URL.revokeObjectURL(url)

  return { success: true }
}
